import React, {useEffect, useState} from 'react';
import {eliminarRuta, inactivarRuta, mostrarRutas} from '../../redux/reducers/rutasReducers';
import AppBar from "../../components/appBar";
import Crear from './crear';
import {
    Button,
    DialogContentText,
    FormControlLabel,
    IconButton,
    List,
    ListItem,
    ListItemIcon,
    ListItemSecondaryAction,
    ListItemText,
    Menu,
    MenuItem,
    SvgIcon,
    Switch
} from "@mui/material";
import PlusFab from "../../components/PlusFab";
import {Block, Close, Edit, GroupOutlined, MoreVertOutlined} from "@mui/icons-material";
import LoadingProgress from "../../components/LoadingProgress";
import {useLocation, useNavigate} from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import {MostrarError} from "../../components/MostrarError";
import Strings from "../../assets/strings";
import {hasPermissionTo, noTilde, PERSMISOS} from "../../helpers";
import {Empty, ListViewMode, SeacrhAppBar} from "../../components";
import {ReactComponent as EmptySvg} from "../../assets/img/map.svg";
import {getIcon} from "../../assets/iconPath";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IRuta} from "../../redux/types/IRuta";
import OrdenarClientes from "./OrdenarClientes";

export default function Rutas() {
    const navigate = useNavigate();
    const Dispatch = useAppDispatch();
    const { list, status, error } = useAppSelector(state => state.rutas);
    const {state:urlState,pathname} = useLocation();
    const [searchBox, setSearchBox] = useState("");
    const [verInactivo, setVerInactivo] = useState(false);
    const [openMenu, setOpenMenu] = React.useState<{
        anchorEl: HTMLElement
        ruta:IRuta
    } | null>(null);

    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>, ruta: IRuta) => {
        setOpenMenu({
            anchorEl: event.currentTarget,
            ruta
        });
    };
    const handleCloseMenu = () => {
        setOpenMenu(null);
    };


    useEffect(() => {
        Dispatch(mostrarRutas({incluirInactivos:verInactivo}));
    }, [Dispatch, verInactivo]);


    const isEmpty = status === "loading" && list.length === 0;


    const filterItems = () => {
        return list.filter(item=> noTilde(item.descripcion).indexOf(noTilde(searchBox)) !== -1);
    }




      return <>
          <AppBar />

          <section className="contentInner" style={!isEmpty ? {maxWidth:600, margin:"0 auto"}:{}}>
              {!urlState && <MostrarError errors={error}/>}
              {status === "loading"  && <LoadingProgress vh/>}
              <ListViewMode pageRows={list?.length} pageTotalRows={list?.length} noView>
                  <FormControlLabel className="d-print-none"
                                    control={
                                        <Switch
                                            size={"small"}
                                            color={"secondary"}
                                            checked={verInactivo}
                                            onChange={()=>setVerInactivo(!verInactivo)}
                                        />
                                    }
                                    label={"Ver Inactivos"}
                  />
                  <SeacrhAppBar name="search" value={searchBox} onChange={({target}:any)=>setSearchBox(target.value)}/>
              </ListViewMode>
              <List >
                  {!isEmpty && filterItems().map(item =>
                      <ListItem role={undefined} key={item.id}
                                // onClick={()=>{
                                //     if(!hasPermissionTo(PERSMISOS.rutasActualizar) || item.inactivo) return false;
                                //     navigate(pathname, {state:item})}}

                                // onClick={(event)=> {
                                //     handleOpenMenu(event, item)
                                // }}


                                sx={item.inactivo? {
                                    background: "#fce8e0 !important"
                                }:(openMenu?.ruta?.id ===  item.id ? {background: "#eeeeee !important"} :{
                                    transition:"background 0.5s",
                                    "&:hover":{
                                        background: "#eeeeee",
                                    }
                                })}
                      >
                          <ListItemIcon>
                              <SvgIcon className="MuiSvgIcon-root jss67"  sx={{color:item.color?item.color:"auto"}}
                                   viewBox="0 0 24 24" aria-hidden="true" tabIndex={-1}
                                   data-ga-event-action="click">
                                  <path  d={getIcon(item.icon || "Place")}></path>
                              </SvgIcon>
                          </ListItemIcon>
                          <ListItemText primary={item.descripcion+` (${item.clientes})`} sx={{color:item.color?item.color:"auto"}}/>
                          <ListItemSecondaryAction>
                              <IconButton
                                  edge="end"
                                  onClick={(event)=>handleOpenMenu(event, item)}
                                  size="large">
                                  <MoreVertOutlined fontSize={"medium"}/>
                              </IconButton>
                          </ListItemSecondaryAction>
                      </ListItem>
                  )}
              </List>
              {list.length === 0 &&
              <Empty Img={EmptySvg} title={Strings.aunNoTienes+" "+Strings.rutas}>
                  <p>{Strings.rutasHelpMsj}</p>
              </Empty>
               }


              {hasPermissionTo(PERSMISOS.rutasCrear) &&
                  <PlusFab component={Button} onClick={()=>navigate(pathname,{state:{id:""}})} />
              }
              <Crear/>


          </section>
          {!!urlState?.delRuta &&
              <ConfirmDialog open onConfirm={()=>Dispatch(eliminarRuta(urlState.delRuta))}/>
          }

          {!!urlState?.blockRuta &&
              <ConfirmDialog mode={"warning"} open onConfirm={()=>Dispatch(inactivarRuta(urlState.blockRuta?.id!))} >
                  <DialogContentText>
                      ¿Seguro que deseas {urlState.blockRuta?.inactivo?" activar ":" inactivar "} esta ruta?
                  </DialogContentText>
              </ConfirmDialog>
          }



          <Menu
              id="basic-menu"
              anchorEl={openMenu?.anchorEl}
              open={Boolean(openMenu?.anchorEl)}
              onClose={handleCloseMenu}
              // anchorPosition={
              //     openMenu !== null
              //         ? { top: 1, left:1 }
              //         : undefined
              // }
          >
              {hasPermissionTo(PERSMISOS.rutasActualizar) && !openMenu?.ruta.inactivo &&
                  <MenuItem
                      onClick={()=> {
                          handleCloseMenu()
                          navigate(pathname, {state:openMenu?.ruta})
                      }}
                  >
                      <ListItemIcon>
                          <Edit fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Editar</ListItemText>

                  </MenuItem>
              }
              {!openMenu?.ruta.inactivo &&

                  <MenuItem
                      onClick={()=>{
                          handleCloseMenu()
                          navigate(pathname, {state: {ordenarPorRuta: openMenu?.ruta}})

                      }}
                  >
                      <ListItemIcon>
                        <GroupOutlined fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Clientes</ListItemText>
                  </MenuItem>
          }
              {hasPermissionTo(PERSMISOS.rutasEliminar) &&
                  <MenuItem
                      onClick={()=>{
                          handleCloseMenu()
                          navigate(pathname, {state: {blockRuta: {id: openMenu?.ruta?.id, inactivo: openMenu?.ruta?.inactivo}}})
                      }}
                      className={openMenu?.ruta?.inactivo ? "text-blue-deep":"text-orange-deep"}
                  >
                      <ListItemIcon>
                          <Block fontSize="small" />
                      </ListItemIcon>
                      <ListItemText > {openMenu?.ruta?.inactivo ?"Activar":"Inactivar"}</ListItemText>
                  </MenuItem>
              }

              {hasPermissionTo(PERSMISOS.rutasEliminar) &&
                  <MenuItem
                      onClick={()=>{
                          handleCloseMenu()
                          navigate(pathname, {state: {delRuta: openMenu?.ruta?.id}})
                      }}
                      className={"text-red-deep"}
                  >
                      <ListItemIcon>
                          <Close sx={{color: "error.main"}} fontSize="small" />
                      </ListItemIcon>
                      <ListItemText>Eliminar</ListItemText>
                  </MenuItem>
              }
          </Menu>


        <OrdenarClientes/>
      </>;

}

